import { ChatConversation } from '@/hooks/useChat';

import { CommandGroup } from '@/components/ui/Command';

import { ConversationGroupItem } from './ConversationGroupItem';

interface ConversationGroupProps {
  heading: string;
  conversations: ChatConversation[];
  currentConversationId: string | null;
  onSelect: (id: string) => void;
}

export const ConversationGroup = (props: ConversationGroupProps) => (
  <>
    {props.conversations.length > 0 && (
      <CommandGroup heading={props.heading}>
        {props.conversations.map((conversation) => (
          <ConversationGroupItem
            key={conversation.id}
            conversation={conversation}
            isActive={props.currentConversationId === conversation.id}
            onSelect={props.onSelect}
          />
        ))}
      </CommandGroup>
    )}
  </>
);
